<template>
    <div class="container">
        <Stats/>
        <iframe src="https://dm.itmaster.dk/view/msTF1fHvk5TgVV1PLU6lJl0scuTW74Md"/>
    </div>
</template>
<style scoped lang="scss">
    .container{
        display: flex;
        flex-direction: column;
        .stats{
            min-height: 200px;
            
        }
        iframe{
            min-height: 500px;
            border: none;
        }
    }
</style>
<script>
import Stats from '@/components/overview/Stats.vue'

export default {
    name: 'Overview',
    components: {
    Stats,
  },
}
</script>